import {
  BuupassAuthConfig,
  BuupassAuthSessionConfig,
  BuupassAuthSharedCookieConfig
} from './types/auth-config';

export interface ResolvedBuupassAuthConfig extends Omit<BuupassAuthConfig, 'session'> {
  session: Required<BuupassAuthSessionConfig>;
  sharedCookie: Required<Omit<BuupassAuthSharedCookieConfig, 'domain' | 'name'>> & {
    domain: string | null;
    name?: string;
  };
}

const defaultSessionConfig: Required<BuupassAuthSessionConfig> = {
  syncProfileOnBootstrap: true
};

const defaultSharedCookieConfig: ResolvedBuupassAuthConfig['sharedCookie'] = {
  enabled: true,
  name: 'buupass_shared_session',
  userCookieName: 'bp_shared_auth_user',
  stateCookieName: 'bp_shared_auth_state',
  domain: null,
  autoResolveDomain: true,
  path: '/',
  sameSite: 'Lax',
  secure: 'auto',
  maxAgeSeconds: 60 * 60 * 24 * 7
};

export function mergeAuthConfig(config: BuupassAuthConfig): ResolvedBuupassAuthConfig {
  return {
    ...config,
    session: {
      ...defaultSessionConfig,
      ...(config.session || {})
    },
    sharedCookie: {
      ...defaultSharedCookieConfig,
      ...(config.sharedCookie || {})
    }
  };
}
